import './ReceiptProgressBar.css'

const ReceiptProgressBar = ({ receivedQuantity, totalQuantity, showLabel = true }) => {
  const percentage = totalQuantity > 0 ? Math.min((receivedQuantity / totalQuantity) * 100, 100) : 0
  const pendingQuantity = totalQuantity - receivedQuantity

  return (
    <div className="receipt-progress-bar">
      {showLabel && (
        <div className="progress-label">
          <span>Recibido: {receivedQuantity}</span>
          <span>Pendiente: {pendingQuantity}</span>
        </div>
      )}
      <div className="progress-bar-container">
        <div 
          className="progress-bar-fill" 
          style={{ width: `${percentage}%` }}
        >
          <span className="progress-percentage">{Math.round(percentage)}%</span>
        </div>
      </div>
    </div>
  )
}

export default ReceiptProgressBar

